<template>
    <div class="amazonKey-events-main-container">
        <div class="options-wrapper">
            <BasicDatePicker v-model="date" @changeDate="changeDate" />
            <BasicDropdown
                name="amazonKey-events-options"
                v-model="event"
                :options="eventsOptions"
                :neededPlaceholder="true"
                @update:modelValue="updateFilters"
            />
        </div>
        <div class="mobile-filter">
            <BasicButton color="light-grey" @click="openFilerModale">
                <i class="fa-regular fa-filter"></i>
            </BasicButton>
        </div>
        <div class="events-content-wrapper">
            <div class="table-content" v-if="!loading">
                <table>
                    <thead>
                        <tr>
                            <th>{{ $t("amazonKey.events.head.date&time") }}</th>
                            <th>{{ $t("amazonKey.events.title") }}</th>
                        </tr>
                    </thead>
                    <tbody v-if="eventsList.length > 0">
                        <tr v-for="(event, index) in eventsList" :key="index">
                            <td>{{ event.date }}</td>
                            <td>{{ getEvent(event) }}</td>
                        </tr>
                    </tbody>
                    <tbody v-else>
                        <tr class="no-result">
                            <td colspan="2">
                                {{ $t("global.array.noSearchData") }}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div v-else class="loader">
                <Loader></Loader>
            </div>
        </div>
        <div class="pagination-wrapper">
            <Pagination
                :pagesCount="pages"
                :page="page"
                @new-current-page="updatePage"
            />
        </div>
    </div>
</template>

<script>
import BasicDropdown from "@/components/basic/BasicDropdown.vue"
import BasicDatePicker from "@/components/basic/BasicDatePicker.vue"
import BasicButton from "@/components/basic/BasicButton.vue"
import Pagination from "@/components/basic/Pagination.vue"
import Loader from "@/components/basic/Loader.vue"

import { getEventsAmazonKey } from "@/services/intratone/amazonKey"

export default {
    components: {
        BasicDropdown,
        BasicDatePicker,
        BasicButton,
        Pagination,
        Loader,
    },
    data() {
        return {
            date: "",
            event: {
                name: this.$t("amazonKey.events.title"),
                value: 0,
            },
            eventsOptions: [
                {
                    name: this.$t("amazonKey.events.title"),
                    value: 0,
                },
                {
                    name: this.$t("amazonKey.events.options.authorized"),
                    value: 1,
                },
                {
                    name: this.$t("amazonKey.events.options.unauthorized"),
                    value: 2,
                },
                {
                    name: this.$t("amazonKey.events.options.on"),
                    value: 3,
                },
                {
                    name: this.$t("amazonKey.events.options.off"),
                    value: 4,
                },
            ],
            eventsList: [],
            loading: false,
            limit: 10,
            page: 1,
            pages: 0,
        }
    },

    async mounted() {
        await this.retrieveEvents()
    },

    methods: {
        async retrieveEvents(event, date) {
            this.loading = true
            this.eventsList = []

            // Params retrieve in URL with Filters modale for mobile view
            if (date !== undefined) {
                this.date = date
            }

            // Params retrieve in URL with Filters modale for mobile view
            if (event !== undefined) {
                this.event = this.eventsOptions.find((item) => {
                    return parseInt(item.value) === parseInt(event)
                })
            }

            // Find corresponding events
            const status = this.filterEvents()

            let params = {
                date: this.date,
                event: status.event,
                state: status.state,
                page: this.page,
                limit: this.limit,
            }

            await getEventsAmazonKey(this.$route.params.accessId, params)
                .then((response) => {
                    if (response.data) {
                        this.page = response.data._page
                        this.pages = response.data._pages

                        if (response.data.list.length > 0) {
                            this.noResult = false

                            // Parse date infos to display it
                            response.data.list.forEach((event) => {
                                let dates = event.add_at.split("-")

                                let day = dates[2].split(" ")[0]
                                let month = dates[1]
                                let year = dates[0]

                                let hour = dates[2].split(" ")[1]

                                this.eventsList.push({
                                    date: `${day}/${month}/${year} - ${hour}`,
                                    event: event.event,
                                    state: event.state,
                                })
                            })
                        } else {
                            this.noResult = true
                        }
                    }
                })
                .finally(() => {
                    this.loading = false
                })
        },

        changeDate(value) {
            this.date = value
            this.page = 1

            this.retrieveEvents()
        },

        // Set data when we switch from Events selection
        filterEvents() {
            let event
            let state

            switch (this.event.value) {
                case 0:
                    event = null
                    state = null
                    break

                case 1:
                    event = "UNLOCK"
                    state = "OK"
                    break

                case 2:
                    event = "UNLOCK"
                    state = "ERROR"
                    break

                case 3:
                    event = "ACTIVATE"
                    state = "OK"
                    break

                case 4:
                    event = "DEACTIVATE"
                    state = "OK"
                    break
            }

            return {
                event: event,
                state: state,
            }
        },

        // Retrieve corresponding trads with data
        getEvent(event) {
            // Activate
            if (event.event === "ACTIVATE" && event.state === "OK") {
                return this.$t("amazonKey.events.options.on")
            }
            // Deactivate
            else if (event.event === "DEACTIVATE" && event.state === "OK") {
                return this.$t("amazonKey.events.options.off")
            }
            // Unauthorized
            else if (event.event === "UNLOCK" && event.state === "OK") {
                return this.$t("amazonKey.events.options.authorized")
            }
            // Authorized
            else if (event.event === "UNLOCK" && event.state === "ERROR") {
                return this.$t("amazonKey.events.options.authorized")
            }
            // Erro
        },

        updateFilters() {
            this.page = 1

            this.retrieveEvents()
        },

        updatePage(value) {
            this.page = value

            this.retrieveEvents()
        },

        // Used only on mobile view
        openFilerModale() {
            this.openModal(
                "amazon-key-filters",
                {
                    statusOptions: this.eventsOptions,
                    applyFunction: (event, date) => {
                        this.page = 1
                        this.retrieveEvents(event, date)
                    },
                },
                null,
                "left-side"
            )
        },
    },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/global.scss";
.amazonKey-events-main-container {
    display: flex;
    flex-direction: column;
    gap: 1em;
    width: 100%;
    height: 100%;
    max-height: 100%;
    // max-width: 100%;

    .options-wrapper {
        display: none;

        @media all and (min-width: 768px) {
            display: flex;
            gap: 1em;
            max-width: 500px;
        }
    }

    .mobile-filter {
        @media all and (min-width: 768px) {
            display: none;
        }
    }

    .events-content-wrapper {
        width: 100%;
        display: flex;
        flex-direction: column;
        flex: 1 1 0;
        overflow: hidden;
        min-height: 0;

        .table-content {
            flex: 1 1 0;
            overflow: auto;
            min-height: 0;
            table {
                min-width: max-content;
                width: 100%;

                thead {
                    // width: 100%;
                    position: sticky;
                    top: 0;
                    background-color: $white;

                    th {
                        padding: 1em 0px;
                        border-bottom: 1px solid $grey-light;

                        &:nth-child(1) {
                            width: 200px;
                        }
                    }
                }

                tr {
                    border-bottom: 1px solid $grey-light;

                    td {
                        padding: 1em 0px;
                        min-width: max-content;
                    }

                    &.no-result {
                        border-bottom: 0px solid $grey-light;
                        font-family: $font_avenir_heavy;
                        color: $pink;
                        text-align: center;
                    }
                }
            }
        }

        .loader {
            width: 100%;
            height: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
        }
    }

    .pagination-wrapper {
        display: flex;
        width: 100%;
        min-height: max-content;
    }
}
</style>
